import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

export function OneTapReferee({ game, onDone }) {
  const [refs, setRefs] = useState([]);
  const [v, setV] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/referees").then(r => setRefs(r.data)).catch(() => {}); }, []);
  const save = async () => {
    if (!v) return;
    setBusy(true);
    try { const { data } = await api.post(`/bookings/${game.booking_id}/record-referee`, { referee_id: v }); toast.success(`${data.referee_name} recorded as referee`); onDone?.(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div className="flex items-center gap-1 mt-1" data-testid={`one-tap-ref-${game.booking_id}`}>
      <select value={v} onChange={e => setV(e.target.value)} className="bg-transparent border border-border rounded px-2 py-1 text-[11px] outline-none focus:border-[#83B68B] max-w-[200px]" data-testid={`one-tap-ref-select-${game.booking_id}`}>
        <option value="">Who refereed?</option>
        {refs.map(r => <option key={r.id} value={r.id} className="bg-background">{r.name}{r.is_qualified ? " ✓" : ""}</option>)}
      </select>
      <button type="button" disabled={!v || busy} onClick={save} className="btn-volt text-[10px] tracking-widest uppercase px-2 py-1 rounded inline-flex items-center gap-1 disabled:opacity-40" data-testid={`one-tap-ref-save-${game.booking_id}`}><Check className="w-3 h-3" /> Record</button>
    </div>
  );
}
